var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBanner(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 814,
    height: 458,
    viewBox: "0 0 814 458",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5832_359881)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 814,
    height: 458,
    fill: "#EEF0F0"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 698,
    height: 154,
    transform: "translate(58 152)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113,
    y: 188,
    width: 174,
    height: 41,
    fill: "#9CA5A9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113,
    y: 243,
    width: 137,
    height: 29,
    fill: "#D5D8DA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 605,
    y: 209,
    width: 102,
    height: 40,
    rx: 8,
    fill: "#007BC1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 477,
    y: 212,
    width: 117,
    height: 34,
    rx: 5,
    stroke: "#007BC1",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("rect", {
    width: 698,
    height: 154,
    transform: "translate(58 -26)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113,
    y: 10,
    width: 281,
    height: 41,
    fill: "#9CA5A9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113,
    y: 65,
    width: 80,
    height: 29,
    fill: "#D5D8DA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 201,
    y: 65,
    width: 119,
    height: 29,
    fill: "#D5D8DA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 584,
    y: 31,
    width: 123,
    height: 40,
    rx: 8,
    fill: "#80BDE0"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 698,
    height: 154,
    transform: "translate(58 330)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113,
    y: 366,
    width: 220,
    height: 41,
    fill: "#9CA5A9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113,
    y: 421,
    width: 174,
    height: 29,
    fill: "#D5D8DA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 496,
    y: 387,
    width: 91,
    height: 40,
    rx: 8,
    fill: "#4DA3D4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 595,
    y: 387,
    width: 112,
    height: 40,
    rx: 8,
    fill: "#007BC1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5832_359881"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 814,
    height: 458,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBanner);
export default __webpack_public_path__ + "static/media/banner.ffe64f56f48646def288243001a44ae1.svg";
export { ForwardRef as ReactComponent };